export const colors = {
  primaryColor: '#243592',
  secondaryColor: '#223369',
  yellow: '#F2CD35',
  indigo: '#526DC4',
  white: '#FFFFFF',
  gray: '#DFDFDF',
  black: '#000',
  red: '#ff4d4f'
}